import { KAI_CHAT_CONFIGS } from '../constants/kaiChatConfig';

/** Shell route → specialist Kai service key */
export const ROUTE_TO_KAI_SERVICE = {
  '/denials': 'denial_management',
  '/claims': 'claims_processing',
  '/charges': 'charge_capture',
  '/insurance': 'insurance_verification',
  '/prior-auth': 'prior_authorization',
  '/ar-posting': 'ar_posting',
  '/eob': 'remittance_advice',
  '/compliance': 'rcm_compliance',
  '/clinical-compliance': 'rcm_compliance',
  '/contract-management': 'contract_management',
  '/appointments': 'patient_portal',
  '/messages': 'patient_portal',
  '/billing': 'patient_portal',
  '/records': 'patient_portal',
  '/help': 'kai_support',
  '/contact-us': 'kai_support',
};

const MESSAGE_KEYWORD_ROUTES = [
  { pattern: /\b(denial|denials|appeal|remark code|carc|rarc)\b/i, serviceKey: 'denial_management' },
  { pattern: /\b(prior auth|authorization|pa request)\b/i, serviceKey: 'prior_authorization' },
  { pattern: /\b(eligibility|insurance verif|benefits check)\b/i, serviceKey: 'insurance_verification' },
  { pattern: /\b(claim submission|claims process|837|cms-1500)\b/i, serviceKey: 'claims_processing' },
  { pattern: /\b(charge capture|cpt|icd|hcpcs|coding)\b/i, serviceKey: 'charge_capture' },
  { pattern: /\b(ar posting|payment post|era|835|reconcil)\b/i, serviceKey: 'ar_posting' },
  { pattern: /\b(remittance|eob|era payment)\b/i, serviceKey: 'remittance_advice' },
  { pattern: /\b(compliance|ncci|mue|timely filing)\b/i, serviceKey: 'rcm_compliance' },
  { pattern: /\b(contract|fee schedule|credentialing)\b/i, serviceKey: 'contract_management' },
  { pattern: /\b(appointment|patient portal|prescription|lab result)\b/i, serviceKey: 'patient_portal' },
  { pattern: /\b(support|help me|how do i|navigate|troubleshoot)\b/i, serviceKey: 'kai_support' },
];

export function resolveKaiServiceFromPath(pathname = '/') {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  const entries = Object.entries(ROUTE_TO_KAI_SERVICE).sort((a, b) => b[0].length - a[0].length);
  const match = entries.find(([route]) => normalized === route || normalized.startsWith(`${route}/`));
  return match ? match[1] : 'platform';
}

export function resolveKaiServiceFromMessage(message, fallbackServiceKey = 'platform') {
  if (!message || typeof message !== 'string') return fallbackServiceKey;
  const hit = MESSAGE_KEYWORD_ROUTES.find(({ pattern }) => pattern.test(message));
  return hit ? hit.serviceKey : fallbackServiceKey;
}

export function getKaiServiceLabel(serviceKey) {
  return KAI_CHAT_CONFIGS[serviceKey]?.serviceName || 'Platform';
}

export const PLATFORM_KAI_SHELL_PORTS = new Set(['3160', '3161', '3260', '3225', '80', '443', '']);

export function shouldUseShellKaiProxy() {
  if (typeof window === 'undefined' || !window.location) return false;
  const { hostname, port } = window.location;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  if (isLocal && (port === '3000' || port === '3001')) return false;
  if (isLocal && !PLATFORM_KAI_SHELL_PORTS.has(port)) return false;
  return true;
}
